import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Paper, Chip, CircularProgress,
  List, ListItem, ListItemIcon, ListItemText, Divider,
} from '@mui/material';
import { FiberManualRecord as BulletIcon } from '@mui/icons-material';
import { releasesAPI } from '../services/api';

const Changelog = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await releasesAPI.getAll();
        setReleases(res.data.releases || []);
      } catch (err) {
        // silently fail
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} mb={0.5}>
        What's New
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Recent updates and improvements to Second Clear
      </Typography>

      {releases.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">No updates yet. Check back soon!</Typography>
        </Paper>
      ) : (
        releases.map((release, index) => {
          const items = Array.isArray(release.items) ? release.items : [];
          const date = release.published_at
            ? new Date(release.published_at).toLocaleDateString('en-US', {
                year: 'numeric', month: 'long', day: 'numeric',
              })
            : '';

          return (
            <React.Fragment key={release.version}>
              <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 2 }}>
                <Box display="flex" alignItems="center" gap={1.5} mb={1} flexWrap="wrap">
                  <Chip
                    label={`v${release.version}`}
                    size="small"
                    color="primary"
                    variant={index === 0 ? 'filled' : 'outlined'}
                    sx={{ fontFamily: 'monospace', fontWeight: 600 }}
                  />
                  {date && (
                    <Typography variant="caption" color="text.secondary">
                      {date}
                    </Typography>
                  )}
                </Box>
                <Typography variant="subtitle1" fontWeight={500} mb={1}>
                  {release.title}
                </Typography>
                <List dense disablePadding>
                  {items.map((item, i) => (
                    <ListItem key={i} disablePadding sx={{ py: 0.4, alignItems: 'flex-start' }}>
                      <ListItemIcon sx={{ minWidth: 24, mt: 1 }}>
                        <BulletIcon sx={{ fontSize: 8, color: index === 0 ? 'primary.main' : 'text.disabled' }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{ variant: 'body2', lineHeight: 1.6 }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </React.Fragment>
          );
        })
      )}
    </Box>
  );
};

export default Changelog;
